"use client";
import { useEffect, useRef, useState } from "react";
import styles from "./BetaAnnouncement.module.css";
import { SharedHeader, type HeaderAccount } from "./SharedHeader";
import { BetaAnnouncement } from "./BetaAnnouncement";
import type { DemoIdentity } from "@/features/workbench/server/demo-access";
export type { HeaderAccount } from "./SharedHeader";
export function SiteHeaderClient(props: { navigationPrefetch?: false; account: HeaderAccount | null; unreadNotifications?: number; demoNotificationIdentity?: DemoIdentity }) {
  const announcementRef = useRef<HTMLDivElement>(null);
  const [announcementHeight, setAnnouncementHeight] = useState(0);

  useEffect(() => {
    const element = announcementRef.current;
    if (!element) return;
    const measure = () => setAnnouncementHeight(element.getBoundingClientRect().height);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return <>
    <div className={styles.headerStack}>
      <div ref={announcementRef}><BetaAnnouncement /></div>
      <SharedHeader {...props} fixed />
    </div>
    <div style={{ height: announcementHeight }} aria-hidden="true" />
    <div className="wb-site-offset" aria-hidden="true" />
  </>;
}
